import getStore from '../store/store';

export default function getIsWindowMaximized(windowId: string = 'default'): boolean {
    return !!getStore().maximized.get(windowId);
}
